<template>
    <div class="theme-sidebar">
        <div class="d-flex flex-column font-sm" :class="dynamicClasses">

            <div class="px-3 mb-2">
                <label class="form-label">Name</label>
                <input type="text" class="form-control" id="nameInput" placeholder="Theme name"
                       v-model="theme.name">
            </div>

            <div class="accordion text-sm" id="accordionContainer">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            Backgrounds
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne" data-bs-parent="#accordionContainer">
                        <div class="accordion-body">
                            <background-editor :background="theme.primary_background" background-type="Primary"></background-editor>
                            <hr class="my-2">
                            <background-editor :background="theme.secondary_background" background-type="Secondary"></background-editor>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                            Fonts
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo" data-bs-parent="#accordionContainer">
                        <div class="accordion-body">
                            <font-style-editor :font="theme.header_font" text-type="Header"></font-style-editor>
                            <hr class="my-2">
                            <font-style-editor :font="theme.text_font" text-type="Text"></font-style-editor>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                            Buttons
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree" data-bs-parent="#accordionContainer">
                        <div class="accordion-body">
                            <button-style-editor :button="theme.primary_button" style-type="Primary" @refreshTheme="onRefreshTheme"></button-style-editor>
                            <hr class="my-3">
                            <button-style-editor :button="theme.secondary_button" style-type="Secondary" @refreshTheme="onRefreshTheme"></button-style-editor>
                        </div>
                    </div>
                </div>

                <div class="accordion-item">
                    <h2 class="accordion-header" id="navAccordionHeader">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navAccordionPanel">
                            Top Nav
                        </button>
                    </h2>
                    <div id="navAccordionPanel" class="accordion-collapse collapse" data-bs-parent="#accordionContainer">
                        <div class="accordion-body">
                            <bg-and-color-editor :component="theme.nav" component-type="Top Nav"></bg-and-color-editor>
<!--                            <hr class="my-3">-->
<!--                            <bg-and-color-editor :component="theme.footer" component-type="Footer"></bg-and-color-editor>-->
                        </div>
                    </div>
                </div>

                <div class="accordion-item">
                    <h2 class="accordion-header" id="miscAccordionHeader">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#miscAccordionPanel">
                            Other Components
                        </button>
                    </h2>
                    <div id="miscAccordionPanel" class="accordion-collapse collapse" data-bs-parent="#accordionContainer">
                        <div class="accordion-body">
                            <card-style-editor :card="theme.card" @refreshTheme="onRefreshTheme"></card-style-editor>
                            <hr class="my-3">
                            <link-style-editor :link="theme.link"></link-style-editor>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="model.auth_token" class="m-2">
            <button class="btn btn-primary btn-sm" @click="onSaveClick">save</button>
        </div>

    </div>
</template>

<script>

import ColorPicker from "../components/ColorPicker.vue";
import BackgroundEditor from "./BackgroundEditor.vue";
import FontStyleEditor from "./FontStyleEditor.vue";
import ButtonStyleEditor from "./ButtonStyleEditor.vue";
import CardStyleEditor from "./CardStyleEditor.vue";
import ThemeService from "../services/ThemeService";
import BgAndColorEditor from "./BgAndColorEditor.vue";
import LinkStyleEditor from "./LinkStyleEditor.vue";
import ThemeLoader from "../utils/ThemeLoader";

export default {
    name: 'ThemeSidebar',
    components: {
        LinkStyleEditor,
        BgAndColorEditor, CardStyleEditor, ButtonStyleEditor, FontStyleEditor, BackgroundEditor, ColorPicker},
    props: ['theme', 'dynamicClasses'],
    data () {
        return {
            model: webase.model,
            service: new ThemeService()
        }
    },
    computed: {
        isOwner() {
            return this.model.currentUser.id !== null && this.model.currentUser.id === this.theme.user_id
        }
    },
    methods: {
        onSaveClick() {
            let request = {
                theme: this.theme
            }

            let promise = this.theme.id === null ? this.service.create(request) : this.service.update(this.theme.id, request)
            promise.then((response) => {
                console.log('theme saved')
                console.log(response)
                this.refreshThemes()
            }).catch((message) => {
                console.log('error saving theme')
                console.log(message)
            })
        },

        onRefreshTheme() {
            ThemeLoader.previewTheme(this.theme)
        },

        refreshThemes() {
            ThemeLoader.loadThemes()
        }
    }
}
</script>

<style>

</style>
